import { render } from "./TopOutliers.vue?vue&type=template&id=29684358"
import script from "./TopOutliers.vue?vue&type=script&lang=js"
export * from "./TopOutliers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__